/**
 * 统一格式化语言代码：替换 - . 为 _
 */
export const normalizeLang = (code: string): string => {
  return code?.replace(/[-.]/g, "_") || "";
};
